<!--配置列表-->
<template>
  <div class="list">
    <div class="listPage" v-for="item in list" :key="item.id">
      <span>{{ $timetransition(item['log_time']) }}</span>
      <!-- 只能输网络参数 -->
      <span>{{ $t(paramsType[item.type].title) }}</span>
      <span>{{ configFn(item['step_code']) }}</span>
      <el-button
        type="text"
        size="small"
        :title="$t('public.details')"
        icon="el-icon-tickets"
        @click="showConfigDetail(item)"
      ></el-button>
    </div>
    <!-- 命令详情 -->
    <cmd-dialog
      :isShow.sync="configDetailAttrs.show"
      :title="configDetailAttrs.title"
      :cmdObj="cmdObj"
      ref="configLogDia"
    />
  </div>
</template>
<script>
import { configStep, paramsType } from '@/utils/convert'
import { getConfigLogContent } from '@/api/modules/deviceUrl'

export default {
  name: 'ConfigList',
  components: {
    // 只能异步导入这个组件 暂不清楚是什么原因导致的
    CmdDialog: () =>
      import(
        '@/pages/equipment/sensor/components/sensor/cionfig/children/CmdDialog.vue'
      )
  },
  computed: {
    paramsType () {
      return paramsType
    }
  },

  props: {
    // 配置历史列表
    list: {
      type: Array,
      default: () => []
    },
    // 传感器行数据 可以提供rowData
    sensorInfo: {
      type: Object,
      default: () => {}
    },
    // 配置状态
    configStatus: {
      type: Number,
      default: 2
    }
  },
  data () {
    return {
      // 命令配置详情传入的参数
      configDetailAttrs: {
        title: '',
        show: false
      },
      cmdObj: null
    }
  },
  methods: {
    configFn (value) {
      return this.$t(configStep[value].title)
    },
    showConfigDetail (row) {
      this.configDetailAttrs.show = true
      const type = this.$t(paramsType[row.type].title)
      this.configDetailAttrs.title = `[${
        row.deviceName
      }][${type}] ${$t('integration.configuration_details')} [${this.$timetransition(row.logTime)}]`

      // 1~6的传感器使用传值  以上的传感器全部在里面获取
      if (this.sensorInfo.type >= 1 && this.sensorInfo.type <= 6) {
        this.isShow = true
        getConfigLogContent({ configLogId: row.id }, 'sensor').then(
          ({ result }) => {
            if (result) {
              const JsonContent = JSON.parse(result.content)
              let childrenContent = ''
              if (JsonContent.content) {
                childrenContent = JSON.parse(JsonContent.content)
              }
              let url = this.sensorInfo.scopeName
              if (this.sensorInfo.sceneName) {
                url += '/' + this.sensorInfo.sceneName
              }
              if (this.sensorInfo.carrierName) {
                url += '/' + this.sensorInfo.carrierName
              }
              this.cmdObj = {
                full_path: url,
                carrierName: this.sensorInfo.carrierName,
                device_name: JsonContent.device_name,
                device_type: JsonContent.device_type,
                status: JsonContent.status,
                step: result.stepCode,
                type: JsonContent.type,
                // 从外层获取详细
                description: this.sensorInfo.description,
                config_status: this.configStatus,
                // content 内容
                cmd: childrenContent.cmd,

                ...childrenContent.item
              }
            } else {
              this.cmdObj = {}
            }
          }
        )
      } else {
        this.$refs.configLogDia.open(this.sensorInfo, row)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.list {
  max-height: 200px;
  overflow: auto;
}

.listPage {
  height: 40px;
  width: 100%;
  margin-top: 15px;
  padding: 0 15px;
  box-sizing: border-box;
  border-radius: 2px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.listPage > span {
  margin-right: 30px;
}

.listPage > .el-button {
  margin-left: auto;
}
</style>
